
import { Capacitor } from '@capacitor/core';

export const isNativeApp = Capacitor.isNativePlatform();

